import is, { isNot } from 'typescript-styled-is'
import styled, { ITheme } from '../../theme'

const Color = styled.div<IColorProps>`
  width: ${props =>
    props.width ? props.width : props.size ? `${30 * props.size}px` : '30px'};
  height: ${props =>
    props.height ? props.height : props.size ? `${30 * props.size}px` : '30px'};

  min-width: ${props =>
    props.width ? props.width : props.size ? `${30 * props.size}px` : '30px'};
  min-height: ${props =>
    props.height ? props.height : props.size ? `${30 * props.size}px` : '30px'};

  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ size }) => (size ? 7 * size : 7)}px
    ${({ size }) => (size ? 7 * size : 7)}px;

  border-radius: 50%;

  ${is('small')`
    width: ${({ size }) => (size ? 24 * size : 24)}px;
  	height: ${({ size }) => (size ? 24 * size : 24)}px;
  	min-width: ${({ size }) => (size ? 24 * size : 24)}px;
  	min-height: ${({ size }) => (size ? 24 * size : 24)}px;
  `};

  ${is('extraSmall')`

    width: ${({ size }) => (size ? 18 * size : 18)}px;
  	height: ${({ size }) => (size ? 18 * size : 18)}px;
  	min-width: ${({ size }) => (size ? 18 * size : 18)}px;
  	min-height: ${({ size }) => (size ? 18 * size : 18)}px;
  `};

  background-color: ${props => props.color};

  ${isNot('width', 'height', 'small', 'extraSmall', 'static')`
  	@media (max-width: ${props => props.theme.breakpoints.mobile}) {
    	width: ${({ size }) => (size ? 45 * size : 45)}px;
    	height: ${({ size }) => (size ? 45 * size : 45)}px;
  	}
  `};

  ${is('selected')`
    transform: scale(1.3);
    transform-origin: center;
	`}

  ${is('bordered')`
		border: solid 1px ${(props: ITheme) => props.theme.colors.border};;
		color: #000;
	`}
`

export default Color

export interface IColorProps {
  selected?: boolean
  color: string
  bordered?: boolean
  small?: boolean
  size?: number
  height?: string
  width?: string
  extraSmall?: boolean
  static?: boolean
}
